import React, { useEffect, useMemo, useState } from 'react';
import PostsGrid from '../../components/PostsGrid';
import { ISOToCountry } from '../../functions/isoToCountry';
import { post } from '../../mocks/postsMocks/postsStore';
import fetchers from '../../functions/fetch';

const ExplorePage: React.FC<{ search: string }> = ({ search }) => {
  const [posts, setPosts] = useState<post[]>([]);
  useEffect(() => {
    fetchers.get_posts({}).then((res) => {
      if (res.status === 200) {
        setPosts(res.data.posts);
      }
    });
  }, []);

  const filteredPosts = useMemo(() => search
    ? posts.filter(({ location, user_name, hotelName }) => {
      const searchStr = search.toLowerCase();
      // TODO: implement elastic search
      return location.city.toLowerCase().includes(searchStr)
        || ISOToCountry(location.country_code).toLowerCase().includes(searchStr)
        || user_name.toLowerCase().includes(searchStr)
        || hotelName.toLowerCase().includes(searchStr); // For searching by hotel name for now
    })
    : posts.filter(({ pick }) => !!pick), [posts, search]); // Only show non-picks while searching
  return (
    <PostsGrid posts={filteredPosts} />
  );
};

export default ExplorePage;
